// keep this consistent with backend plan.go
export enum FeatureKeys {
	SSO = 'sso',
	USE_SPAN_METRICS = 'use_span_metrics',
	ONBOARDING = 'onboarding',
	CHAT_SUPPORT = 'chat_support',
	GATEWAY = 'gateway',
	PREMIUM_SUPPORT = 'premium_support',
	ANOMALY_DETECTION = 'anomaly_detection',
	ONBOARDING_V3 = 'onboarding_v3',
	DOT_METRICS_ENABLED = 'dot_metrics_enabled',
	USE_JSON_BODY = 'use_json_body',
}
